namespace Gamification.Gamification {
    export interface ApiScriptCodiceForm {
        Codice: Serenity.TextAreaEditor;
        Descrizione: Serenity.TextAreaEditor;
    }

    export class ApiScriptCodiceForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ApiScriptCodice';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApiScriptCodiceForm.init)  {
                ApiScriptCodiceForm.init = true;

                var s = Serenity;
                var w0 = s.TextAreaEditor;

                Q.initFormType(ApiScriptCodiceForm, [
                    'Codice', w0,
                    'Descrizione', w0
                ]);
            }
        }
    }
}
